import axios from "axios";
import { JWT_KEY } from "../../config/constant";
import request, { BaseResponse } from "../core";
import { clearAuthStorage } from "../../utils/authStorage";
import {
  IUserInfoGetResponse,
  IUserInfoPatchRequest,
  IUserProcessGetRequest,
  IUserProcessGetResponse,
  IVerifyAccessTokenGetResponse,
} from "../../interface/auth";

export const verifyAccessToken = async () => {
  return await request.get<BaseResponse<IVerifyAccessTokenGetResponse>>(
    `/app/users/verify/token`
  );
};

export const getUserInfo = async (token?: string) => {
  if (token) {
    return await request.get<BaseResponse<IUserInfoGetResponse>>(
      `/app/users/me`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } else
    return await request.get<BaseResponse<IUserInfoGetResponse>>(
      `/app/users/me`
    );
};

export const logoutService = async () => {
  const currentRefreshToken =
    window.localStorage.getItem("brainy_refresh_token") ?? "";
  // LocalStorage에 FCM 토큰 조회
  const fcmToken = window.localStorage.getItem("fcmToken") ?? "";
  return await request.patch<BaseResponse<boolean>>(
    `/app/users/logout`,
    {
      fcmToken: fcmToken,
    },
    {
      headers: {
        refreshToken: `Bearer ${currentRefreshToken}`,
      },
    }
  );
};

export const renewAccessToken = async (): Promise<string | null> => {
  const currentRefreshToken =
    window.localStorage.getItem("brainy_refresh_token") ?? "";

  const currentAccessToken = window.localStorage.getItem(JWT_KEY) ?? "";

  if (
    !currentRefreshToken ||
    currentRefreshToken === "" ||
    !currentAccessToken ||
    currentAccessToken === ""
  ) {
    clearAuthStorage();
    return null;
  } else {
    // 2026-04-19 fix(#4): 재발급 요청도 동일한 15초 타임아웃 부여 (core 인스턴스 미경유)
    const response = await axios.post(
      `${process.env.REACT_APP_API}/app/users/renew/token`,
      {},
      {
        headers: {
          refreshToken: `Bearer ${currentRefreshToken}`,
          Authorization: `Bearer ${currentAccessToken}`,
        },
        timeout: 15_000,
      }
    );
    if (response.data.code != 200) {
      clearAuthStorage();
      return null;
    }
    window.localStorage.setItem(
      "brainy_refresh_token",
      response.data.result.refreshToken
    );
    window.localStorage.setItem(
      "brainy_access_token",
      response.data.result.accessToken
    );
    console.log(response.data);
    if (window.webkit)
      try {
        window.webkit?.messageHandlers?.getToken.postMessage({
          accessToken: response.data.result.accessToken,
          refreshToken: response.data.result.refreshToken,
        });
      } catch (e: any) {
        console.log(e);
      }
    else if (window.Android)
      window.Android?.saveAccessToken(response.data.result.accessToken);

    return response.data.result.accessToken;
  }
};

export const deleteUser = async () => {
  return await request.delete<BaseResponse<boolean>>(`/app/users`);
};

export const patchUserStatus = async (token?: string) => {
  if (token)
    return await request.patch<BaseResponse<boolean>>(
      `/app/users/user-status`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  else
    return await request.patch<BaseResponse<boolean>>(`/app/users/user-status`);
};

export const getUserProcess = async (params: IUserProcessGetRequest) => {
  return await request.get<BaseResponse<IUserProcessGetResponse>>(
    `/app/users/verify/user-process`,
    {
      params,
    }
  );
};

export const patchUserInfo = async (data: IUserInfoPatchRequest) => {
  return await request.patch<BaseResponse<boolean>>(
    `/app/users/user-info`,
    data
  );
};
